export enum Status {
    LOADING,
    ERROR,
    OK
}
